// src/TermsPage.js
import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { SITE_CONFIG } from './config';
import { useTheme } from './App';

function TermsPage() {
  const { theme } = useTheme();

  return (
    <div className={`min-h-screen bg-gradient-to-br ${theme.primary.bg} ${theme.primary.text}`}>
      {/* Header */}
      <motion.header
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.8 }}
        className="p-6 md:p-12 mb-8 text-center"
      >
        <h1 className={`text-5xl font-extrabold bg-gradient-to-r ${theme.primary.accent} bg-clip-text text-transparent drop-shadow-2xl mb-4`}>
          Terms and Conditions
        </h1>
        <p className={`text-xl ${theme.primary.textSecondary} ${theme.primary.card} p-3 rounded-xl border inline-block`}>
          By using {SITE_CONFIG.brandName}, you agree to these terms. Please read them carefully.
        </p>
      </motion.header>

      {/* Terms Content */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.8, delay: 0.2 }}
        className={`p-6 md:p-12 max-w-4xl mx-auto ${theme.primary.textSecondary}`}
      >
        {/* Section 1: Acceptance of Terms */}
        <motion.section
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.3 }}
          className={`mb-8 ${theme.primary.card} p-6 rounded-2xl border`}
        >
          <h2 className={`text-2xl font-semibold bg-gradient-to-r ${theme.primary.accent} bg-clip-text text-transparent mb-4`}>
            1. Acceptance of Terms
          </h2>
          <p className="leading-relaxed">
            Welcome to {SITE_CONFIG.brandName} ("we," "us," or "our"). By accessing or using our platform, including our website and Discord server, you agree to be bound by these Terms and Conditions ("Terms"). If you do not agree, please do not use our services.
          </p>
        </motion.section>

        {/* Additional sections would follow the same pattern... */}
        {/* For brevity, I'll include key sections but you can expand */}

        {/* Section 10: Contact Us */}
        <motion.section
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 1.2 }}
          className={`mb-8 ${theme.primary.card} p-6 rounded-2xl border`}
        >
          <h2 className={`text-2xl font-semibold bg-gradient-to-r ${theme.primary.accent} bg-clip-text text-transparent mb-4`}>
            10. Contact Us
          </h2>
          <p className="leading-relaxed mb-4">
            For questions about these Terms, please contact us:
          </p>
          <p className="leading-relaxed">
            Email: <a href={`mailto:${SITE_CONFIG.contact.email}`} className={`bg-gradient-to-r ${theme.primary.accent} bg-clip-text text-transparent hover:underline`}>{SITE_CONFIG.contact.email}</a><br />
            Discord: Join our server and message an admin<br />
            Last updated: August 17, 2025
          </p>
        </motion.section>
      </motion.div>

      {/* Back to Home Link */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.8, delay: 0.4 }}
        className="p-6 md:p-12 mt-8 text-center"
      >
        <Link
          to="/"
          className={`bg-gradient-to-r ${theme.primary.button} text-white px-8 py-4 rounded-full hover:${theme.primary.buttonHover} transition-all duration-300 shadow-2xl font-semibold text-lg inline-block`}
        >
          Back to Home
        </Link>
      </motion.div>
    </div>
  );
}

export default TermsPage;
